import { ILegalGroup } from "../../../models/response/legal-document/ILegalGroup";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLegalGroupDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as ILegalGroup[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as ILegalGroup | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ILegalGroup,
    SAVE_SUCESSS: {} as ILegalGroup,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESSS: {} as ILegalGroup,
    DELETE_ERROR: "",
}
export const eLegalGroupActionTypeIds = generateActionTypeIds(eLegalGroupDefine, "LEGAL_GROUP")
export type ILegalGroupActionTypes = IGenericActionType<typeof eLegalGroupDefine, "LEGAL_GROUP">